import React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Statistic } from 'antd'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { numberWithComma } from 'helpers/format'
import { OverallTotalData } from 'Store/minirmx-dashboard/types'

type Props = {
  data?: OverallTotalData
} & ReduxProps

const SummaryReport: React.FunctionComponent<Props> = props => {
  const { data } = props
  const valStyle = {
    color: Theme.colors.primary,
    fontFamily: Theme.fontFamily.regular,
    fontSize: Theme.typography.h4,
  }

  const boxSpan = {
    md: 6,
    xs: 12,
  }
  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BoxTitle>REPORT</BoxTitle>
      </Col>
      <Col md={24} xs={24} sm={24}>
        <BoxWrapper>
          <Row gutter={[16, 16]} justify="center">
            <Col md={boxSpan.md} xs={boxSpan.xs}>
              <BoxStatistic
                title="ยอดขายสินค้าปัจจุบัน"
                value={numberWithComma(data?.current_volume || 0, true)}
                suffix={<Unit>บาท</Unit>}
                valueStyle={valStyle}
              />
            </Col>
            <Col md={boxSpan.md} xs={boxSpan.xs}>
              <BoxStatistic
                title="ยอดขายสินค้าปีที่ผ่านมา"
                value={numberWithComma(data?.last_year_volume || 0, true)}
                suffix={<Unit>บาท</Unit>}
                valueStyle={valStyle}
              />
            </Col>
            <Col md={boxSpan.md} xs={boxSpan.xs}>
              <BoxStatistic
                title="ผลต่างของยอดขายสินค้า"
                value={numberWithComma(data?.diff_volume_qty || 0, true)}
                suffix={<Unit>บาท</Unit>}
                valueStyle={valStyle}
              />
            </Col>
            <Col md={boxSpan.md} xs={boxSpan.xs}>
              <BoxStatistic
                title="ผลต่างของยอดขายสินค้า"
                value={numberWithComma(data?.diff_volume_per || 0)}
                suffix={<Unit>%</Unit>}
                valueStyle={valStyle}
              />
            </Col>
          </Row>
        </BoxWrapper>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border-radius: 10px;
  border-color: transparent;
`

const BoxStatistic = styled(Statistic)`
  padding: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  //text-align: center;
`

const Legend = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const Unit = styled(Legend)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const mapStateToProps = (state: RootState) => {
  return {}
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(SummaryReport)
